import { collection, addDoc, serverTimestamp, getDocs, query, orderBy, deleteDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';

const getUserGamesCollection = (uid) => collection(db, 'users', uid, 'games');

export const saveGameRecord = async (uid, gameData) => {
  if (!uid) {
    throw new Error('User must be logged in');
  }
  const userGamesRef = getUserGamesCollection(uid);
  await addDoc(userGamesRef, {
    ...gameData,
    createdAt: serverTimestamp(),
  });
};

export const deleteGameRecord = async (uid, gameId) => {
  if (!uid) {
    throw new Error('User must be logged in');
  }
  if (!gameId) {
    throw new Error('Game ID is required');
  }
  const gameDocRef = doc(db, 'users', uid, 'games', gameId);
  await deleteDoc(gameDocRef);
};

export const fetchGameHistory = async (uid) => {
  if (!uid) {
    return [];
  }
  const userGamesRef = getUserGamesCollection(uid);
  const order = orderBy('createdAt', 'desc');
  const snapshot = await getDocs(query(userGamesRef, order));
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};
